import * as React from 'react';
import { useEffect, useState } from 'react';
import { Callout, getTheme, Icon, MessageBar, MessageBarType, Stack, Text } from 'office-ui-fabric-react';
import { useWindowSize } from 'react-use';
import { PrimaryButton } from '../Button/Primary';
import { Nav } from '../Nav';
import { Profile } from '../Profile';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// quick MVP of header and sidemenu

export const Header = _ref => {
  let {
    children,
    user,
    openMenu,
    navLinkGroup,
    onLogout,
    env = 'prod'
  } = _ref;
  const [sideMenuOpen, setSideMenuOpen] = useState(false);
  const {
    height
  } = useWindowSize();
  useEffect(() => {
    if (openMenu) {
      setSideMenuOpen(openMenu);
    }
  }, [openMenu]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      styles: {
        root: {
          background: env === 'prod' ? '#2e68ea' : '#929eaa',
          color: 'white'
        }
      },
      tokens: {
        childrenGap: 5
      },
      children: [/*#__PURE__*/_jsx(Stack, {
        horizontal: true,
        tokens: {
          childrenGap: 10
        },
        horizontalAlign: "end",
        children: /*#__PURE__*/_jsx(Icon, {
          iconName: "GlobalNavButton",
          style: {
            padding: 9,
            fontSize: 25,
            cursor: 'pointer'
          },
          onClick: () => setSideMenuOpen(!sideMenuOpen)
        })
      }), /*#__PURE__*/_jsx(Stack.Item, {
        align: "center",
        grow: 1,
        children: children
      }), /*#__PURE__*/_jsx(Stack.Item, {
        align: "center",
        children: /*#__PURE__*/_jsxs(Stack, {
          horizontal: true,
          horizontalAlign: "end",
          tokens: {
            childrenGap: 5
          },
          style: {
            cursor: 'pointer'
          },
          children: [env !== 'prod' && /*#__PURE__*/_jsx(MessageBar, {
            messageBarType: MessageBarType.warning,
            isMultiline: false,
            dismissButtonAriaLabel: "Close",
            children: "You are on the Buzz ".concat(env, " environment")
          }), user && /*#__PURE__*/_jsx(Profile, {
            user: user,
            children: /*#__PURE__*/_jsx(Stack, {
              horizontal: true,
              horizontalAlign: "center",
              children: /*#__PURE__*/_jsx(PrimaryButton, {
                onClick: () => {
                  if (onLogout) {
                    onLogout();
                  }
                },
                children: "Log Out"
              })
            })
          })]
        })
      })]
    }), sideMenuOpen && /*#__PURE__*/_jsx(Callout, {
      gapSpace: 0,
      coverTarget: true,
      isBeakVisible: false,
      hideOverflow: true,
      calloutMaxHeight: height,
      minPagePadding: 0,
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          background: '#2e68ea',
          color: 'white',
          height: height,
          width: '250px'
        },
        children: [/*#__PURE__*/_jsx(Stack, {
          horizontal: true,
          tokens: {
            childrenGap: 5
          },
          styles: {
            root: {
              borderBottom: 1,
              borderColor: 'white',
              borderBottomStyle: 'solid'
            }
          },
          children: /*#__PURE__*/_jsxs(Stack, {
            horizontal: true,
            tokens: {
              childrenGap: 10
            },
            horizontalAlign: "end",
            children: [/*#__PURE__*/_jsx(Icon, {
              iconName: "ChromeClose",
              style: {
                padding: 14,
                fontSize: 15,
                cursor: 'pointer'
              },
              onClick: () => setSideMenuOpen(!sideMenuOpen)
            }), /*#__PURE__*/_jsx(Stack.Item, {
              align: "center",
              children: /*#__PURE__*/_jsx(Text, {
                variant: "mediumPlus",
                children: "Buzz "
              })
            })]
          })
        }), navLinkGroup && /*#__PURE__*/_jsx(Nav, {
          groups: [navLinkGroup],
          onLinkClick: () => setSideMenuOpen(false),
          ariaLabel: "Nav basic example",
          styles: _ref2 => {
            let {
              isSelected
            } = _ref2;
            return isSelected ? {
              link: {
                color: getTheme().palette.themePrimary
              }
            } : {
              link: {
                color: 'white'
              },
              groupContent: {
                height: '100vh',
                overflowY: 'auto'
              }
            };
          }
        })]
      })
    })]
  });
};